import { render, staticRenderFns } from "./orderfrom.vue?vue&type=template&id=41d3150e&scoped=true&"
import script from "./orderfrom.vue?vue&type=script&lang=js&"
export * from "./orderfrom.vue?vue&type=script&lang=js&"
import style0 from "./orderfrom.vue?vue&type=style&index=0&id=41d3150e&lang=less&scoped=true&"
import style1 from "./orderfrom.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d3150e",
  null
  
)

export default component.exports